import { createContext } from "react";
import { ExamConfiguration } from "../hooks/use-exam-config-mapping";

export type AppContextValue = {
  candidateInfo?: any;
  examConfig?: ExamConfiguration;
  setCandidateInfo: (candidateInfo: any) => void;
  setExamConfig: (config: ExamConfiguration) => void;
};

export const AppContext = createContext<AppContextValue | undefined>(undefined);
